<template lang="pug">

  section.pic
    img(:src="src", alt="Crossfit")

</template>

<script>
  export default  {
    name: 'Pic',
    props: {
      src: {
        type: String,
        default: 'assets/images/_MG_4187.jpg'
      }
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .pic {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: black;
    img{
      transition: all .3s;
      filter: grayscale(100%);
      &:hover{
        filter: grayscale(0);
      }
    }
  }
</style>
